<template>
  <div class="container">
    <div class="form" v-watermark>
      <div class="form-header">问诊信息</div>
      <div class="form-item">
        <div class="label">患者信息</div>
        <div class="value">
          {{ detail.name }} {{ detail.sexStr }} {{ detail.age }}岁
        </div>
      </div>
      <div class="form-item">
        <div class="label">首诊信息</div>
        <div class="infos">
          <div class="p">
            <div class="p-label">首诊医院：</div>
            <div class="p-value">
              <van-field class="border" v-model="detail.hospitalName" placeholder="请输入" :maxlength="20" />
            </div>
          </div>
          <div class="p">
            <div class="p-label">首诊诊断：</div>
            <div class="p-value">
              <van-field class="border" v-model="detail.hospitalDiagnose" placeholder="请输入" :maxlength="20" />
            </div>
          </div>
        </div>
      </div>
      <div class="form-item">
        <div class="label">
          <span>本次问诊病种</span>
          <van-button type="info" size="mini" @click="onDiseaseTypeShow">修改</van-button>
        </div>
        <div class="value">
          <div class="tabs" v-if="detail.subDiseaseTypes && detail.subDiseaseTypes.length">
            <van-tag :type="detail.diseaseType === item ? 'success' : 'primary'" plain
              v-for="(item, index) in detail.subDiseaseTypes" :key="item + '-' + index" closeable
              @click="onDiseaseTypeMain(item)" @close="onDiseaseTypeDelete(index)" size="large">{{
                getDiseaseTypeName(item)
              }}</van-tag>
          </div>
          <div class="tabs" v-else>
            <van-tag type="info" color="#ccc" plain size="large">病种待确认</van-tag>
          </div>
          <!-- <patient-select v-model="detail.diseaseType" :options="options.diseaseType" label-name="value" value-name="key" /> -->
        </div>
      </div>
      <!-- <div class="form-item">
                <div class="label">患病多久</div>
                <div class="value">
                    <patient-select v-model="detail.askIllnessYears" :options="options.askIllnessYears" label-name="text" value-name="text" />
                </div>
            </div> -->
      <!-- <div class="form-item">
                <div class="label">就诊的医院</div>
                <div class="value">
                    <van-field v-model="detail.hospitalName" placeholder="请输入就诊的医院" />
                </div>
            </div> -->
      <!-- <div class="form-item">
                <div class="label">上次医院就诊的结果</div>
                <div class="value">
                    <div class="icd">
                        <div class="icd-box" v-if="detail.icdCode">
                            <div class="name">{{ detail.icdName }}</div>
                            <van-icon name="clear" @click="onIcdClear" />
                        </div>
                        <van-field v-model="detail.icdName" placeholder="请输入上次医院就诊的结果" v-else />

                        <van-icon name="edit" @click="icd.show = true" />
                    </div>

                </div>
            </div> -->
      <div class="form-item">
        <div class="label">
          <span>本次问诊主诉症状</span>
          <van-button type="info" size="mini" @click="onSymptomShow">修改</van-button>
        </div>
        <div class="value">
          <div class="tabs" v-if="detail.symptomIds && detail.symptomIds.length">
            <van-tag type="primary" plain
              v-for="(item, index) in getSymptomTreeChildren.filter(item => detail.symptomIds.includes(item.code))" 
              :key="index" 
              closeable
              size="large"
              @close="detail.symptomIds.splice(index,1)"
              >
              {{ item.name }}
            </van-tag>
          </div>
          <div class="tabs" v-else>
            <van-tag type="info" color="#ccc" plain size="large">症状待确认</van-tag>
          </div>
        </div>
      </div>
      <div class="form-item" v-if="detail.firstAsk == 0">
        <div class="label">服药感受</div>
        <div class="value">
          <van-field class="border" v-model="detail.takeMedicineFeel" placeholder="请输入服药感受" type="textarea" autosize />
        </div>
      </div>
      <div class="form-item">
        <div class="label">病情描述</div>
        <div class="value">
          <van-field class="border" v-model="detail.illness" placeholder="请输入病情描述" type="textarea" autosize />
        </div>
      </div>
      <div class="form-item">
        <div class="label">相关的病情图片：</div>
        <div class="value">
          <TwiceUploads :fileList.sync="detail.images" />
        </div>
      </div>
      <!-- <div class="form-item">
        <div class="label">相关的病情图片：</div>
        <div class="value">
          <van-uploader
            v-model="detail.images"
            :max-count="10"
            :after-read="onUploadAfterRead"
            :before-read="onUploadBeforeRead"
            image-fit="fill"
          />
        </div>
      </div> -->
      <div class="form-item">
        <div class="label">左眼眼睑+右眼眼睑+舌苔+舌下脉络图片</div>
        <div class="value">
          <drag-sort v-model="threeConditionImages">
            <van-uploader v-model="threeConditionImages[index].img" :max-count="1" :after-read="onUploadAfterRead"
              v-for="(item, index) in threeConditionImages" :key="item.id + '-' + index" class="item"
              :before-read="onUploadBeforeRead" image-fit="fill" />
          </drag-sort>
        </div>
      </div>
      <!-- <div class="form-item">
        <div class="label">收货方式</div>
        <div class="value">
          <van-radio-group v-model="detail.deliverType">
            <van-radio :name="1" :icon-size="20">物流</van-radio>
            <van-radio :name="2" :icon-size="20">自取</van-radio>
          </van-radio-group>
        </div>
      </div>
      <template v-if="detail.deliverType == 1">
        <div class="form-item">
          <div class="label">收货人</div>
          <div class="value">
            <van-field v-model="detail.addressName" placeholder="请输入收货人" />
          </div>
        </div>
        <div class="form-item">
          <div class="label">收货电话</div>
          <div class="value">
            <van-field v-model="detail.addressPhone" placeholder="请输入收货电话" />
          </div>
        </div>
        <div class="form-item">
          <div class="label">收货地址</div>
          <div class="value">
            <div class="select" @click="region.show = true">
              <div class="name">{{ detail.addressRegion || "请选择" }}</div>
              <div class="arrow">
                <van-icon name="arrow-down" :size="14" />
              </div>
            </div>
            <van-field class="address" v-model="detail.addressDetail" placeholder="请输入详细地址" />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="form-item">
          <div class="label">收货地址</div>
          <div class="value">用户自取</div>
        </div>
      </template> -->
    </div>
    <div class="form-button">
      <div class="form-button-box">
        <van-button type="info" :loading="!submit" @click="onSubmit">确认修改</van-button>
        <van-button @click="$router.back()" :disabld="!submit">取消修改</van-button>
      </div>
    </div>

    <van-action-sheet v-model="icd.show">
      <van-picker show-toolbar :columns="icd.list" value-key="icdName" @cancel="icd.show = false"
        @confirm="onIcdConfirm" />
    </van-action-sheet>

    <!-- <van-action-sheet v-model="region.show">
      <van-area :value="detail.addressCode" :area-list="region.areaList" @confirm="onRegionConfirm"
        @cancel="onRegionCancel" v-if="region.show" />
    </van-action-sheet> -->

    <van-dialog v-model="diseaseType.show" show-cancel-button :before-close="onDiseaseTypeClose"
      @confirm="onDiseaseTypeConfirm">
      <div class="disease-type-dialog">
        <div class="disease-type-dialog-box">
          <div class="left">
            <div class="list">
              <div class="item" :class="{ disabled: inArray(item.key, diseaseType.active) }"
                v-for="(item, index) in getDiseaseType.filter((row) => row.key !== 0)" :key="index">
                <div class="item-box" @click="onDiseaseTypeChange(item)">
                  {{ item.value }}
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="right-box">
              <van-tag :type="diseaseType.main === item ? 'success' : 'primary'" plain
                v-for="(item, index) in diseaseType.active" :key="index" closeable
                @click="onDiseaseTypeMain(item, true)" @close="onDiseaseTypeDelete(index, true)" size="large">
                {{ getDiseaseTypeName(item) }}
              </van-tag>
            </div>
          </div>
        </div>
      </div>
    </van-dialog>
    <SelectSymptom :showSelectSymptom.sync="symptomState.show" 
                   :symptomIds.sync="detail.symptomIds" 
                   :symptomData="getSymptomTree" 
                   :symptomChildren="getSymptomTreeChildren"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  getAskDetail,
  getDiseaseType,
  uploadOther,
  setAskinfo,
  getAskIllnessYears,
  getIcd,
} from "@/api/index";
import patientSelect from "@/components/patient/select";
import dragSort from "@/components/drag-sort/index.vue";
import Compressor from "compressorjs";
// import { areaList } from "@vant/area-data";
import {
  offlineVisit,
  threeImagesImport,
  threeImagesExport,
  inArray,
} from "@/utils/index";

import SelectSymptom from '@/views/ask/components/selectSymptom.vue';
export default {
  components: {
    patientSelect,
    dragSort,
    SelectSymptom
  },
  computed: {
    ...mapGetters(["getDiseaseTypeName", "getDiseaseType",'getSymptomTree','getSymptomTreeChildren']),
  },  
  data() {
    return {
      detail: {
        diseaseType: "",
        subDiseaseTypes: [],
        deliverType: 1,
        symptomIds:[]
      },
      options: {
        isHospitalVisit: [
          { label: "是", value: 1 },
          { label: "否", value: 0 },
        ],
        diseaseType: [],
        askIllnessYears: [],
      },
      icd: {
        show: false,
        list: [],
      },
      submit: true,
      threeConditionImages: [
        { id: 1, img: [] },
        { id: 2, img: [] },
        { id: 3, img: [] },
        { id: 4, img: [] },
      ],
      // region: {
      //   areaList: areaList,
      //   show: false,
      // },
      diseaseType: {
        show: false,
        active: [],
        main: "",
      },
      symptomState: {
        show: false,
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    offlineVisit,
    inArray,
    init() {
      this.onDataGet();
    },
    onDataGet() {
      getDiseaseType().then(({ data }) => {
          // 获取病种
          this.options.diseaseType = data.list || [];
          return getAskIllnessYears(); //获取问诊信息中的患病多久选项
        }).then(({ data }) => {
          this.options.askIllnessYears = data || [];
          return getAskDetail({ askNo: this.$route.query.askNo }); //获取问诊详情
        }).then(({ data }) => {
          // 问诊详情信息
          // if (!data.icdName && data.diagnose) {
          //     data.icdName = data.diagnose;
          // }
          data.images = data.images ? data.images.split(",").map((item) => ({ url: item })) : [];
          // if (data.userDeliveryAddress) {
          //   //收货地址处理
          //   data.addressRegion =
          //     data.userDeliveryAddress.province +
          //     data.userDeliveryAddress.city +
          //     data.userDeliveryAddress.area; // 显示名称
          //   data.addressDetail = data.userDeliveryAddress.address; //详细地址
          //   data.addressName = data.userDeliveryAddress.name; //姓名
          //   data.addressPhone = data.userDeliveryAddress.phone; //电话
          // } else {
          //   data.userDeliveryAddress = {};
          // }
          if (!data.addressCode) data.addressCode = "";
          data.subDiseaseTypes = data.subDiseaseTypes ? data.subDiseaseTypes.split(",").map((itm) => itm | 0) : data.diseaseType || data.diseaseType === 0 ? [data.diseaseType] : [];
          if (!data.deliverType) data.deliverType = 1;
          data.symptomIds = (data.askDiseaseList || []).map(item=>item.code)
          this.detail = data;
          let threeConditionImages = threeImagesImport(data.threeConditionImages);
          for (let i = 0; i < this.threeConditionImages.length; i++) {
            this.threeConditionImages[i].img = threeConditionImages[i] ? [{ url: threeConditionImages[i] }] : [];
          }
        }).then(() => {
          getIcd({
            pageSize: 100,
            pageNum: 1,
          }).then(({ data }) => {
            this.icd.list = data.list;
          });
        });
    },
    onSubmit() {
      if (!this.submit) return false;
      let form = JSON.parse(JSON.stringify(this.detail));

      let eyeLeft = this.threeConditionImages[0].img; //眼睑
      let eye = this.threeConditionImages[1].img; //眼睑
      let coating = this.threeConditionImages[2].img; //舌苔
      let tongue = this.threeConditionImages[3].img; //舌下脉络

      // let Regexp = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/ // 中国大陆手机号校验
      // let Regexp = /^1\d{10}$/ // 中国大陆手机号校验
      // let dx = /^((133)|(153)|(18[0|1|9])|(191)|(177))[\d]{8}$/ // 校验电信手机号码
      // let hk = /^([69]\d{7})$/ //中国香港地区手机号验证
      // let mo = /^6([68]\d{5})$/ //中国澳门地区手机号验证
      // let tw = /^(09\d{8})$/ //中国台湾地区手机号验证
      // let tel = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/ // 座机
      // if (typeof form.diseaseType !== "number") {
      //   return this.$toast("请选择本次问诊病种");
      // }
      // else if (!form.subDiseaseTypes.length) {
      //   this.$toast("请选择病种");
      //   return false;
      // } 
      // else if (
      //   !(form.diseaseType || form.diseaseType === 0) &&
      //   form.subDiseaseTypes.length > 1
      // ) {
      //   this.$toast("请点击已选病种设置主诉病种");
      //   return false;
      // }
      if (!form.hospitalName.length) {
        this.$toast("请填写首诊医院");
        return false;
      }
      if (!form.hospitalDiagnose.length) {
        this.$toast("请填写首诊诊断");
        return false;
      }
      if (!form.illness) {
        this.$toast("请输入病情描述");
        return false;
      } else if (!eye.length) {
        this.$toast("请上传右眼眼睑图片");
        return false;
      } else if (!coating.length) {
        this.$toast("请上传舌苔图片");
        return false;
      } else if (!tongue.length) {
        this.$toast("请上传舌下脉络图片");
        return false;
      }
      // else if (form.symptomIds?.length === 0) {
      //   this.$toast("请选择主诉症状");
      //   return false;
      // }
      // else if (form.deliverType == 1) {
      //   if (!form.addressName) {
      //     this.$toast("请输入收货人");
      //     return false;
      //   } else if (!form.addressPhone) {
      //     this.$toast("请输入收货电话");
      //     return false;
      //   } else if (
      //     form.addressPhone.charAt() == 1 &&
      //     !/^1\d{10}$/.test(form.addressPhone)
      //   ) {
      //     this.$toast("收货电话格式不正确，请输入正确的手机号码");
      //     return false;
      //   } else if (
      //     ![
      //       /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/,
      //       /^([69]\d{7})$/,
      //       /^6([68]\d{5})$/,
      //       /^(09\d{8})$/,
      //     ].some((item) => item.test(form.addressPhone))
      //   ) {
      //     this.$toast("收货电话格式不正确，请输入正确的电话号码");
      //     return false;
      //   } else if (!form.userDeliveryAddress.province) {
      //     this.$toast("请选择收货地址区域");
      //     return false;
      //   } else if (!form.addressDetail) {
      //     this.$toast("请输入收货详细地址");
      //     return false;
      //   }
      // }

      this.submit = false;

      // 左眼睑置后
      let threeConditionImages = threeImagesExport(
        this.threeConditionImages.map(
          (itm) => (itm.img[0] && itm.img[0].url) || ""
        )
      );

      let send = {
        askNo: this.$route.query.askNo,
        isOfflineVisit: form.isHospitalVisit | 0,
        diseaseType: form.subDiseaseTypes.length == 1 ? form.subDiseaseTypes[0] : form.diseaseType,
        subDiseaseTypes: form.subDiseaseTypes.join(","),
        askIllnessYears: form.askIllnessYears,
        // hospitalName: form.hospitalName,
        // icdName: form.icdName,
        // diagnose: form.icdName,
        // icdCode: form.icdCode,
        askIllness: form.illness,
        threeConditionImages: threeConditionImages.join(","),
        leftBlepharImages: (eyeLeft[0] && eyeLeft[0].url) || "",
        blepharImages: eye[0].url,
        tongueCoatingImages: coating[0].url,
        tongueImages: tongue[0].url,
        askImages: form.images.map((item) => item.url).join(","),
        userDeliveryAddress: {
          // id: form.userDeliveryAddress.id,
          // province: form.userDeliveryAddress.province,
          // city: form.userDeliveryAddress.city,
          // area: form.userDeliveryAddress.area,
          // address: form.addressDetail,
          // name: form.addressName,
          // phone: form.addressPhone,
        },
        takeMedicineFeel: form.takeMedicineFeel,
        deliverType: form.deliverType,
        askDiseaseList: this.getSymptomTreeChildren.filter(item => form.symptomIds.includes(item.code)).map(item => ({ code: item.code, name: item.name, type: 1 })),
        hospitalName: form.hospitalName.trim(),
        hospitalDiagnose: form.hospitalDiagnose.trim()
      }

      setAskinfo(send).then(() => {
          this.$toast("修改成功");
          setTimeout(() => {
            this.submit = true;
            this.$router.back();
          }, 1000);
        }).catch(() => {
          this.submit = true;
        });
    },
    onUploadAfterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      let formData = new FormData();
      formData.append("file", file.file);
      formData.append("module", "efficacy");
      formData.append("category", "track");
      uploadOther(formData).then((res) => {
          if (res.code == 0) {
            file.status = "success";
            file.message = "";
            file.url = res.data.absoluteUrl;
          }
        }).catch((err) => {
          file.status = "failed";
          file.message = "上传失败";
        });
    },
    onUploadBeforeRead(file) {
      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          success: (result) => {
            let newFile = new File([result], file.name, { type: file.type });
            resolve(newFile);
          },
          error(err) {
            console.log(err.message);
          },
        });
      });
    },
    onIcdConfirm(row) {
      this.detail.icdCode = row.icdNo;
      this.detail.icdName = row.icdName;
      this.icd.show = false;
    },
    onIcdClear() {
      this.detail.icdCode = "";
      this.detail.icdName = "";
    },
    onRegionConfirm(arr) {
      //区域选择
      this.detail.userDeliveryAddress.province = arr[0].name;
      this.detail.userDeliveryAddress.city = arr[1].name;
      this.detail.userDeliveryAddress.area = arr[2].name;
      this.detail.addressRegion = arr.map((item) => item.name).join("");
      this.detail.province = this.detail.addressRegion;
      this.detail.addressCode = arr[arr.length - 1].code;
      this.region.show = false;
    },
    onRegionCancel() {
      //区域关闭
      this.region.show = false;
    },
    onDiseaseTypeShow() {
      this.diseaseType.main = this.detail.diseaseType;
      this.diseaseType.active = JSON.parse(
        JSON.stringify(this.detail.subDiseaseTypes)
      );
      this.diseaseType.show = true;
    },
    onDiseaseTypeChange(row) {
      if (!this.inArray(row.key, this.diseaseType.active)) {
        if (
          row.key === 0 ||
          this.diseaseType.active.some((item) => item === 0)
        ) {
          this.diseaseType.active = [];
          this.diseaseType.main = "";
        }
        this.diseaseType.active = this.diseaseType.active.filter(item => item !== null)
        this.diseaseType.active.push(row.key);
      }
    },
    onDiseaseTypeMain(val, isPop) {
      // 设置主诉病种
      if (isPop) {
        if (this.diseaseType.main !== val) {
          this.diseaseType.main = val;
        }
      } else {
        if (this.detail.diseaseType !== val) {
          this.detail.diseaseType = val;
        }
      }
    },
    onDiseaseTypeDelete(index, isPop) {
      // 病种删除
      if (isPop) {
        if (this.diseaseType.active[index] === this.diseaseType.main) {
          this.diseaseType.main = "";
        }
        this.diseaseType.active.splice(index, 1);
      } else {
        if (this.detail.diseaseType === this.detail.subDiseaseTypes[index]) {
          this.detail.diseaseType = "";
        }
        this.detail.subDiseaseTypes.splice(index, 1);
      }
    },
    onDiseaseTypeClose(action, done) {
      if (action == "cancel") {
        done();
      } else {
        done(false);
      }
    },
    onDiseaseTypeConfirm() {
      if (this.diseaseType.active.length <= 0) {
        this.$toast.fail("请选择病种");
        return false;
      } else if (
        !(this.diseaseType.main || this.diseaseType.main === 0) &&
        this.diseaseType.active.length > 1
      ) {
        this.$toast.fail("请点击已选病种设置主诉病种");
        return false;
      }
      this.detail.diseaseType =
        this.diseaseType.active.length == 1
          ? this.diseaseType.active[0]
          : this.diseaseType.main | 0;
      this.detail.subDiseaseTypes = JSON.parse(
        JSON.stringify(this.diseaseType.active)
      );
      this.diseaseType.show = false;
    },
    onSymptomShow() {
      this.symptomState.show = true
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/base";

.container {
  padding: 10px 10px 20px;

  .form {
    background: #fff;
    padding: 15px;

    &-header {
      font-weight: bold;
      font-size: 18px;
      padding-bottom: 10px;
      border-bottom: 1px solid #e6e6e6;
    }

    &-item {
      margin-top: 15px;

      .label {
        color: #808080;
        font-size: 16px;
        display: flex;
        align-items: center;

        .van-button {
          margin-left: 20px;
          height: 24px;
          min-width: 60px;
        }
      }

      .value {
        margin-top: 10px;
        display: flex;

        .select {
          flex: none;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border: 1px solid #e6e6e6;
          padding: 0 10px;
          font-size: 14px;
          height: 30px;
          border-radius: 4px;
          white-space: nowrap;
          min-width: 3em;
          margin-left: 10px;

          &:first-child {
            margin-left: 0;
          }

          .name {
            margin-right: 5px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        .address {
          padding: 0 10px;
          // border: 1px solid #e6e6e6;
          margin-left: 5px;
          border-radius: 4px;
        }

        .textarea {
          width: 100%;
          background: #f6fbff;
        }

        .icd {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;

          &-box {
            flex: 1;
            display: flex;
            align-items: center;

            .van-icon {
              margin-left: 10px;
              cursor: pointer;
            }
          }
        }

        .tabs {
          margin-left: -10px;
          margin-top: -5px;

          .van-tag {
            margin-left: 10px;
            margin-top: 10px;
            cursor: pointer;
          }
        }
      }
      .border {
        border: 1px solid #e5e5e5;
        border-radius: 5px;
        padding: 10px;
      }

      .infos {
        font-size: 18px;
        .p {
          margin-top: 10px;
          &-value {
            margin-top: 10px;
          }
        }
      }

      .item {
        pointer-events: bounding-box;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

      .van-radio-group {
        @include flex();

        .van-radio {
          margin-right: 22px;
        }
      }
    }
  }

  .form-button {
    height: 80px;
    padding-bottom: env(safe-area-inset-bottom);

    &-box {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 10px;
      background: #fff;
      padding-bottom: env(safe-area-inset-bottom);

      .van-button {
        width: 100%;
        margin: 0 10px;
        border-radius: 6px;
      }
    }
  }

  .drag-sort {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .van-cell {
    padding-left: 0;
    padding-top: 5px;

    &::after {
      display: none;
    }
  }

  .disease-type-dialog {
    &-box {
      @include flex();

      .left {
        flex: none;
        width: 40%;
        border-right: 1px solid #e5e5e5;

        .list {
          height: 50vh;
          overflow-y: auto;

          .item {
            &-box {
              padding: 10px 15px;
            }

            &:not(.disabled) {
              .item-box {
                cursor: pointer;

                &:active {
                  background: #f4f4f4;
                }
              }
            }

            &.disabled {
              .item-box {
                color: #999;
                cursor: not-allowed;
              }
            }
          }
        }
      }

      .right {
        &-box {
          padding: 10px;

          .van-tag {
            margin-left: 20px;
            margin-top: 20px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
